import { Modal } from "@components/modal";
import { Button } from "@components/button";
import tableStyles from "@components/row-table/rowTable.module.scss";
import { useForm } from "react-hook-form";
import { Input } from "@components/input";
import {
  AdminWithdrawal,
  AdminWithdrawalUpdateRequest,
} from "@features/admin/withdrawals/api";
import { useAdminWithdrawals } from "@features/admin/withdrawals";
import { useAuth } from "@features/auth";
import { DoubleText } from "@components/table";
import { formatDate, formatTime } from "@helpers/date";
import {
  formatUsdt,
  getTronScanAddresUrl,
  getTronScanTxUrl,
} from "@helpers/format";
import { EllipsisText } from "@components/ellipsis-text";
import { CustomSelect, SelectOption } from "@components/select";
import { useAdminBalances } from "@features/admin/finance";
import { useEffect, useState } from "react";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  data: AdminWithdrawal;
};

export const AdminWithdrawalModal = ({
  hideModal,
  isModalOpen,
  data,
}: Props) => {
  const { isSuperUser } = useAuth();
  const { state, getAdminWalletsForWithdrawals } = useAdminBalances();
  const { control, reset, handleSubmit } =
    useForm<AdminWithdrawalUpdateRequest>();
  const [options, setOptions] = useState<SelectOption[]>([]);

  const { updateAdminWithdrawal, getAdminWithdrawals } = useAdminWithdrawals();
  useEffect(() => {
    getAdminWalletsForWithdrawals();
  }, [getAdminWalletsForWithdrawals]);

  useEffect(() => {
    if (state.withdrawalWallets) {
      setOptions(
        state.withdrawalWallets.map((wallet) => ({
          text: wallet,
          value: wallet,
        }))
      );
    }
  }, [state.withdrawalWallets]);

  useEffect(() => {
    reset({hash: data.hash});
  }, [data])

  const onModalClose = () => {
    reset();
    hideModal();
  };

  const onSubmit = (request: AdminWithdrawalUpdateRequest) => {
    updateAdminWithdrawal(data.id, request).then(() => {
      getAdminWithdrawals();
    });
    reset();
    hideModal();
  };

  const cancel = () => {
    updateAdminWithdrawal(data.id, { cancel: true }).then(() => {
      getAdminWithdrawals();
    });
    reset();
    hideModal();
  };

  return (
    <Modal isOpen={isModalOpen} onClose={onModalClose} title={" "}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <table className={tableStyles.main}>
          <tbody>
            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Адрес</td>
              <td className={tableStyles.cellData}>
                <EllipsisText
                  text={data.address}
                  copy
                  link={getTronScanAddresUrl(data.address)}
                />
              </td>
            </tr>

            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>HASH</td>
              <td className={tableStyles.cellData}>
                <EllipsisText
                  text={data.hash}
                  copy
                  link={getTronScanTxUrl(data.hash)}
                />
              </td>
            </tr>

            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>К переводу</td>
              <td className={tableStyles.cellData}>{data.amount + " USDT"}</td>
            </tr>
            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Комиссия</td>
              <td className={tableStyles.cellData}>
                {formatUsdt(data.commission)}
              </td>
            </tr>
            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Списание</td>
              <td className={tableStyles.cellData}>
                {data.commission + data.amount + " USDT"}
              </td>
            </tr>
            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Дата и время</td>
              <td className={tableStyles.cellData}>
                <DoubleText
                  text={formatTime(new Date(data.created))}
                  subText={formatDate(new Date(data.created))}
                />
              </td>
            </tr>

            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Кошелек вывода</td>
              <td className={tableStyles.cellData}>
                <CustomSelect
                  control={control}
                  name="our_address"
                  disabled={!isSuperUser}
                  options={options}
                />
              </td>
            </tr>

            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>HASH</td>
              <td className={tableStyles.cellData}>
                <Input
                  name="hash"
                  control={control}
                  placeholder="hash"
                  disabled={!isSuperUser || data.status != "Ожидание"}
                />
              </td>
            </tr>

            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Статус</td>
              <td className={tableStyles.cellData}>{data.status}</td>
            </tr>

            <tr className={tableStyles.row}>
              <td className={tableStyles.cellTitle}>Email аккаунта</td>
              <td className={tableStyles.cellData}>{data.email}</td>
            </tr>
          </tbody>
        </table>
        <div style={{ display: "flex", gap: "5px" }}>
          <Button
            disabled={!isSuperUser || data.status != "Ожидание"}
            buttonType="button"
            type="danger"
            onClick={cancel}
          >
            Отменить
          </Button>
          <Button disabled={!isSuperUser || data.status != "Ожидание"}>Сохранить</Button>
        </div>
      </form>
    </Modal>
  );
};
